import React, {
  PropsWithChildren,
  createContext,
  useContext,
  useState,
} from "react";

interface LoadingContent {
  loading: boolean;
  setLoading: (loading: boolean) => void;
}

export const LoadingContext = createContext<LoadingContent>({
  loading: false,
  setLoading: () => ({}),
});

export const LoadingProvider: React.FC<PropsWithChildren> = ({ children }) => {
  const [loading, setLoading] = useState<boolean>(false);

  const value = { loading, setLoading };

  return (
    <LoadingContext.Provider value={value}>{children}</LoadingContext.Provider>
  );
};

export const useLoadingContext = () => useContext(LoadingContext);
